export default "__VITE_ASSET__569a5763__"